__turbopack_context__.v({
  "alignEnd": "hero-v2-module-scss-module__4o2HyG__alignEnd",
  "backgroundContainer": "hero-v2-module-scss-module__4o2HyG__backgroundContainer",
  "bgVideo": "hero-v2-module-scss-module__4o2HyG__bgVideo",
  "bottom": "hero-v2-module-scss-module__4o2HyG__bottom",
  "buttons": "hero-v2-module-scss-module__4o2HyG__buttons",
  "buttonsCentered": "hero-v2-module-scss-module__4o2HyG__buttonsCentered",
  "centerAligned": "hero-v2-module-scss-module__4o2HyG__centerAligned",
  "centered": "hero-v2-module-scss-module__4o2HyG__centered",
  "centeredTop": "hero-v2-module-scss-module__4o2HyG__centeredTop",
  "column-inner": "hero-v2-module-scss-module__4o2HyG__column-inner",
  "contain": "hero-v2-module-scss-module__4o2HyG__contain",
  "container": "hero-v2-module-scss-module__4o2HyG__container",
  "contentContainer": "hero-v2-module-scss-module__4o2HyG__contentContainer",
  "copy-container": "hero-v2-module-scss-module__4o2HyG__copy-container",
  "copyContainer": "hero-v2-module-scss-module__4o2HyG__copyContainer",
  "cover": "hero-v2-module-scss-module__4o2HyG__cover",
  "fullWidth": "hero-v2-module-scss-module__4o2HyG__fullWidth",
  "gapLarge": "hero-v2-module-scss-module__4o2HyG__gapLarge",
  "gapMedium": "hero-v2-module-scss-module__4o2HyG__gapMedium",
  "gapSmall": "hero-v2-module-scss-module__4o2HyG__gapSmall",
  "gapXLarge": "hero-v2-module-scss-module__4o2HyG__gapXLarge",
  "hasBackgroundImage": "hero-v2-module-scss-module__4o2HyG__hasBackgroundImage",
  "hidden": "hero-v2-module-scss-module__4o2HyG__hidden",
  "imageContainer": "hero-v2-module-scss-module__4o2HyG__imageContainer",
  "isCarousel": "hero-v2-module-scss-module__4o2HyG__isCarousel",
  "justifyCenter": "hero-v2-module-scss-module__4o2HyG__justifyCenter",
  "justifyLeft": "hero-v2-module-scss-module__4o2HyG__justifyLeft",
  "mobileBackgroundImageContainer": "hero-v2-module-scss-module__4o2HyG__mobileBackgroundImageContainer",
  "mobileBackgroundVideoContainer": "hero-v2-module-scss-module__4o2HyG__mobileBackgroundVideoContainer",
  "paddingMobile": "hero-v2-module-scss-module__4o2HyG__paddingMobile",
  "prePostHeaderText": "hero-v2-module-scss-module__4o2HyG__prePostHeaderText",
  "rowReverse": "hero-v2-module-scss-module__4o2HyG__rowReverse",
  "supporting-copy": "hero-v2-module-scss-module__4o2HyG__supporting-copy",
  "supportingCopyWrapper": "hero-v2-module-scss-module__4o2HyG__supportingCopyWrapper",
  "textCenter": "hero-v2-module-scss-module__4o2HyG__textCenter",
  "top": "hero-v2-module-scss-module__4o2HyG__top",
  "videoContainer": "hero-v2-module-scss-module__4o2HyG__videoContainer",
  "winnersBadge": "hero-v2-module-scss-module__4o2HyG__winnersBadge",
});
